module.exports = __webpack_public_path__ + "img/mcp-sticky-banner-img.2b39bba4.png";